'use strict';

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/chart.js/src/charts/Chart.Doughnut.js
// module id = ../../../../chart.js/src/charts/Chart.Doughnut.js
// module chunks = 5